// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PaymentPlanPopup__pad-left{padding-left:30px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-quoteandbind-common-react/pages/Quote/PaymentPlanPopup.module.scss"],"names":[],"mappings":"AAAA,iCACI,iBAAA","sourcesContent":[".pad-left {\n    padding-left: 30px;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pad-left": "app__PaymentPlanPopup__pad-left"
};
export default ___CSS_LOADER_EXPORT___;
